export const isAccountMember = () => {
  if (typeof window.reactGlobals.role !== "string") {
    return false;
  }
  return window.reactGlobals.role.toLowerCase() === "mobilesecure";
};
